export default __webpack_public_path__ + "static/media/remoteCulture.5b78dbb2.gif";